var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01111 15.9768L3.20371 18.4518L4.87426 16.6658V28.9537L13.3216 28.9576V19.4326H16.7006V28.9591L25.148 28.9629V16.6498L26.827 18.4427L29.0111 15.9772L15.0111 0.962891L1.01111 15.9768ZM24.4722 28.1999L17.3764 28.1965V18.6696H12.6458V28.1942L5.55005 28.1912V15.9433L15.0111 5.82818L24.4722 15.9284V28.1999ZM3.21655 17.3875L1.97952 15.9929L15.0111 2.01423L28.0427 15.9929L26.8138 17.3784L15.0111 4.7776L3.21655 17.3875Z",
    fill: "#0E0F0F",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.828266 15.8063L0.6733 15.9725L0.823979 16.1426L3.01658 18.6176L3.19869 18.8232L3.38629 18.6226L4.62426 17.299V28.9537V29.2036L4.87415 29.2037L13.3215 29.2076L13.5716 29.2077V28.9576V19.6826H16.4506V28.9591V29.209L16.7005 29.2091L25.1478 29.2129L25.398 29.213V28.9629V17.2825L26.6445 18.6136L26.8321 18.8139L27.0141 18.6085L29.1982 16.143L29.3489 15.9729L29.194 15.8067L15.194 0.792398L15.0111 0.596308L14.8283 0.792396L0.828266 15.8063ZM12.3958 18.6696V27.9441L5.80005 27.9413V16.042L15.0112 6.19401L24.2222 16.0272V27.9498L17.6264 27.9466V18.6696V18.4196H17.3764H12.6458H12.3958V18.6696ZM26.8087 17.0073L15.1936 4.6067L15.011 4.41176L14.8285 4.60683L3.22145 17.0163L2.3174 15.9971L15.0111 2.38085L27.7048 15.9971L26.8087 17.0073Z",
    stroke: "#0E0F0F",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e1d9c640.svg";
export { ForwardRef as ReactComponent };